import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

export function useSidebarKeyboardShortcuts(toggleShortcutModalFn) {
  const keyboardEvents = {
    '$mod+Slash': {
      action: () => toggleShortcutModalFn(true),
    },
    '$mod+Escape': {
      action: () => toggleShortcutModalFn(false),
    },
  };

  return useKeyboardEvents(keyboardEvents);
}
